<a
  class="sidebar-item no-decoration flex flex--middle"
  [class.hovered-background]="hoveredBG()"
  [class.active]="active()"
  [finLink]="link()"
  [external]="external()"
  [finElemTracker]="trackingObj()?.tracker"
  [finElemContext]="trackingObj()?.context"
  [finElemType]="trackingObj()?.type"
  [openInNewTab]="openInNewTab()"
  [attr.aria-current]="active() ? 'page' : null"
  [attr.aria-disabled]="active() ? 'true' : null"
  (click)="onLinkClick($event)"
  [ngClass]="[(isNewBrand() ? 'ps-large-r ps-small-l ' : 'ps-small-x ') + styleClasses()]"
  tabindex="0"
>
  {{ title() }}
  @if (active()) {
    <span class="is-vishidden">{{ 'navigation.currentPage' | finLocalization }}</span>
  }
  @if (external()) {
    <fcom-icon
      class="icon-small ms-xxsmall-l"
      [dataTestId]="'icon-' + SvgLibraryIcon.EXTERNAL_TAB"
      [name]="SvgLibraryIcon.EXTERNAL_TAB"
    />
  }
  @if (loginRequired()) {
    <fcom-icon
      class="icon-small ms-xxsmall-l"
      [dataTestId]="'icon-' + SvgLibraryIcon.LOCK_OPEN"
      [name]="SvgLibraryIcon.LOCK_OPEN"
    />
  }
</a>
